import * as React from "react";

;
export const AssetActionAdd = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.75 24V0h-1.5v11.25H0v1.5h11.25V24h1.5zM24 12.75h-9.76v-1.5H24v1.5z" fill="#100722" /></svg>;